import { render, staticRenderFns } from "./bettingConfig.vue?vue&type=template&id=372c78d4&"
import script from "./bettingConfig.vue?vue&type=script&lang=js&"
export * from "./bettingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports